import React from "react";
import { Card, Image } from "antd";

const YourNotesComponent: React.FC<{
  note: string;
}> = (props) => {
  const { note } = props;
  return (
    <>
      <Card bordered={false} className="ss-card ss-card__note">
        <h2 className="ss-title">Your Note - It's Real</h2>
        <div className="ss-card__note-img">
          <Image src={note} alt="note img" width={200} />
        </div>
      </Card>
    </>
  );
};

export default YourNotesComponent;
